import * as React from 'react';

function SvgPayoutListActionCancel(props) {
  return (
    <svg width={16} height={16} fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 0a8 8 0 100 16A8 8 0 008 0zM1.6 8a6.4 6.4 0 011.352-3.92l8.968 8.968A6.399 6.399 0 011.6 8zm11.448 3.92L4.08 2.952a6.4 6.4 0 018.968 8.968z" />
    </svg>
  );
}

export default SvgPayoutListActionCancel;
